import {generateGeoJsonObjectFromFeature, setGeoJsonLayerSegments} from "@/helpers/ol/ol-geo-json-helper";
import {WKT} from "ol/format";
import {toLonLat, transform} from 'ol/proj'
import {getLength, getArea} from "ol/sphere";
import {getLocationByLngLat} from "@/http/services/http-services-route";
import {getCenter} from "ol/extent";
import {convertToDMS} from "@/helpers/lat-lon-helper";
import {setGeometryLocation} from "@/helpers/layer/info/layer-info-info-geometry-helper";

import {getLatLonProjectionName} from "@/helpers/ol/ol-projection-helper";
import {initHideButton} from "@/helpers/layer/info/layer-info-helper";

export function loadInfoItemGeometryMeasure(feature, featureIndex, mainTabIndex, name = '') {

    const geoJson = generateGeoJsonObjectFromFeature(feature, false)

    if(!geoJson) {
        return
    }
    //// console.log(geoJson)

    const olFeature = geoJson[0]
    const olGeometry = olFeature.getGeometry()
    const olGeometryType = olGeometry.getType()

    const format = new WKT()
    const wkt = format.writeGeometry(olGeometry);
    const xy = olGeometry.getCoordinates().join(', ')

    let ll = ''
    let surface = ''
    let outline = ''

    let innerHtml = `
        <div class="card m-3 bg-lighter" style="border-radius: 10px;min-height:460px">
             <div class="card-header font-weight-bold p-2 info-menu-info-draggable">
                 Meten <span class="text-lowercase">` + name + `</span>
                <button class="btn icon-btn btn-sm btn-outline-secondary float-right btnCloseInfoMenu" data-parent-element="layer-info-info">
                    <span class="fa fa-times"></span>
                </button>
                <layer-info-info-geometry-measure-back-button></layer-info-info-geometry-measure-back-button>
             </div>
                <div class="measure-scroll">
             <div class="card ml-2 mr-2 mt-2">
            <div class="card-header p-2">
                <a href="#" class="font-weight-bold text-dark accordion-header d-block" data-bs-toggle="collapse" data-bs-target="#collapse-measure" aria-expanded="true"> 
                   ` + olGeometryType + `
                    <div class="collapse-icon float-right"></div>
                 </a>  
            </div>
            <div class="collapse show pb-2 pt-1" id="collapse-measure" style="">
                <div class="card-body pl-2 pr-2">`

    switch (olGeometryType) {
        case 'Point':
            ll = transform(olGeometry.getCoordinates(), 'EPSG:28992', getLatLonProjectionName()).reverse().join(', ')

        innerHtml += `      
                    <div class="row">
                        <div class="col-5">XY</div>
                        <div class="col-7">` + xy + `</div>
                    </div>
                    <div class="row">
                        <div class="col-5">LL</div>
                        <div class="col-7">` + ll + `</div>
                    </div>`
            break;
        case 'Polygon':
        case 'MultiPolygon':
            surface = olGeometry.getArea().toFixed(2)
            outline = getLength(olGeometry).toFixed(2)

            innerHtml += `     
                <div class="row">
                    <div class="col-5">Oppervlakte</div>
                    <div class="col-7">` + surface + ` m2</div>
                </div>
                <div class="row">
                    <div class="col-5">Omtrek</div>
                    <div class="col-7">` + outline + ` m</div>
                </div>`

            if(window.height3D) {
                innerHtml += `   
                <div class="row">
                    <div class="col-5">Hoogte</div>
                    <div class="col-7">` + window.height3D + ` m</div>
                </div>
            `
            }

            break;
        case 'LineString':
        case 'MultiLineString':

            outline = getLength(olGeometry).toFixed(2)

            innerHtml += `   
                <div class="row">
                    <div class="col-5">Lengte</div>
                    <div class="col-7">` + outline + ` m</div>
                </div>
            `
            break;
    }

    innerHtml += `  
                        <div class="row">
                            <div class="col-5">WKT</div>
                            <div class="col-7"><input title="` + wkt + `" type="text" value="` + wkt +`" class="form-control"></div>
                        </div>
                         </div>
                 </div>
            </div>`

    innerHtml += `
        <div class="card ml-2 mr-2 mt-2">
            <div class="card-header p-2">
                <a href="#" class="font-weight-bold text-dark accordion-header d-block" data-bs-toggle="collapse" data-bs-target="#collapse-measure-segments" aria-expanded="true"> 
                    Maatvoering
                    <div class="collapse-icon float-right"></div>
                </a>
            </div>
            <div class="collapse show pb-2 pt-1" id="collapse-measure-segments" style="">
                <div class="card-body pl-2 pr-2">
                    <div class="row">
                        <layer-info-info-geometry-measure-segments data-index="` + mainTabIndex + `" data-feature-index="` + featureIndex + `"></layer-info-info-geometry-measure-segments>
                    </div>
                </div>
             </div>
        </div>`

    innerHtml += `
        <div class="card ml-2 mr-2 mt-2">
            <div class="card-header p-2">
                <a href="#" class="font-weight-bold text-dark accordion-header" data-bs-toggle="collapse" data-bs-target="#collapse-measure-buffer" aria-expanded="true"> 
                    Buffer maken rondom dit object
                    <div class="collapse-icon float-right"></div>
                </a>
            </div>
            <div id="collapse-measure-buffer" class="collapse show pb-2 pt-1" style="">
                <div class="card-body pl-2 pr-2">
                    <layer-info-info-geometry-measure-buffer></layer-info-info-geometry-measure-buffer>
                </div>
             </div>
        </div>`


    innerHtml += ` 
            <div class="card ml-2 mr-2 mt-2 measureBuffer d-none">
                <div class="card-header p-2">
                    <a href="#" class="font-weight-bold text-dark accordion-header d-block" data-bs-toggle="collapse" data-bs-target="#collapse-buffer" aria-expanded="true"> 
                        Buffer
                        <div class="collapse-icon float-right"></div>
                     </a>  
                </div>
                <div class="collapse show pb-2 pt-1" id="collapse-buffer" style="">
                    <div class="card-body pl-2 pr-2">
                         <div class="row">
                            <div class="col-5">Oppervlakte</div>
                            <div class="col-7"><span class="measureSurface"></span> m2</div>
                        </div>
                        <div class="row">
                            <div class="col-5">Omtrek</div>
                            <div class="col-7"><span class="measureOutline"></span> m</div>
                        </div>
                         <div class="row">
                            <div class="col-5">WKT</div>
                            <div class="col-7"><input type="text" class="form-control measureWkt"></div>
                        </div>
                    </div>
                </div>
            </div>
                
        `

    window.measureOlFeature = olFeature
    window.measureOlFeatureDefault = olFeature

    if(olGeometryType === 'LineString') {
        innerHtml += `
        <div class="card ml-2 mr-2 mt-2" id="divCardMeasureAhn">
            <div class="card-header p-2">
                <a href="#" class="font-weight-bold text-dark accordion-header d-block" data-bs-toggle="collapse" data-bs-target="#collapse-measure-ahn" aria-expanded="true">
                    Genereer Hoogteprofiel
                    <div class="collapse-icon float-right"></div>
                </a>
            </div>
            <div id="collapse-measure-ahn" class="collapse show pb-2 pt-1" style="">
                <div class="card-body pl-2 pr-2">
                    <layer-info-info-geometry-measure-ahn-profile data-geometry-type="${olGeometryType}"></layer-info-info-geometry-measure-ahn-profile>
                </div>
             </div>
             </div>
        </div>`

    } else {
        innerHtml += `
        <div class="card ml-2 mr-2 mt-2" id="divCardMeasureAhn">
            <div class="card-header p-2">
                <a href="#" class="font-weight-bold text-dark accordion-header d-block" data-bs-toggle="collapse" data-bs-target="#collapse-measure-ahn" aria-expanded="true">
                    3D locatie <span class="measureBuffer d-none">van buffer</span>
                    <div class="collapse-icon float-right"></div>
                </a>
            </div>
            <div id="collapse-measure-ahn" class="collapse show pb-2 pt-1" style="">
                <div class="card-body pl-2 pr-2">
                    <layer-info-info-geometry-measure-ahn data-geometry-type="${olGeometryType}" data-index=""></layer-info-info-geometry-measure-ahn>
                </div>
             </div>
             </div>
        </div>`

    }


    innerHtml +=`</div>`
    const element = document.querySelector('layer-info-info-geometry-measure')
    element.innerHTML = innerHtml

    setGeometryLocation(olFeature, 'layer-info-info-geometry-measure', name, feature.id, '.measure-scroll')

    initHideButton()

    return 'success'
}

